import type PlanDTO from "../../Models/DTOs/Plan";

export function getStripeProvider(plan?: PlanDTO | null) {
    return plan?.paymentProviders?.find(p => p?.providerName?.toLowerCase() === "stripe");
}
export function getStripePriceId(plan?: PlanDTO | null): string | undefined {
    return getStripeProvider(plan)?.providerPriceId;
}
export function getStripeDiscount(plan?: PlanDTO | null): string | null {
    if (!plan) return null;
    const stripeProv = getStripeProvider(plan);
    if (!stripeProv) return null;
    if (plan.promotionIsActive && stripeProv.campaign?.campaignCouponId) {
        return stripeProv.campaign.campaignCouponId;
    }
    if (stripeProv.standard?.stdCouponId) {
        return stripeProv.standard.stdCouponId;
    }
    return null;
}

export function getStripeMarketingCoupon(plan?: PlanDTO | null): string | undefined {
    if (!plan) return undefined;
    const stripeProv = getStripeProvider(plan);
    if (!stripeProv) return undefined;
    if (plan.promotionIsActive && stripeProv.campaign?.campaignCouponId) {
        return stripeProv.campaign.campaignCouponId;
    }

    return undefined;
}
